export const formatDimensions = (numberValue, locale, isInch, forceDecimalPlaces = false) => {
  // Safety check: return '-' if numberValue is not valid
  if (numberValue === null || numberValue === undefined || typeof numberValue !== 'number' || isNaN(numberValue)) {
    return '-'
  }

  const decimalPlaces = isInch ? 3 : 2
  if (forceDecimalPlaces) {
    return numberValue.toLocaleString(locale, {minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces})
  }

  const roundedValue = numberValue.toFixed(decimalPlaces)
  if (roundedValue % 1 === 0) {
    return numberValue.toFixed(0)
  }
  return numberValue.toLocaleString(locale, {minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces})
}
